module.exports = __webpack_public_path__ + "static/media/img-2.906aff26.png";